(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@wangeditor/editor"));
	else if(typeof define === 'function' && define.amd)
		define(["@wangeditor/editor"], factory);
	else if(typeof exports === 'object')
		exports["WangEditorPluginUploadAttachment"] = factory(require("@wangeditor/editor"));
	else
		root["WangEditorPluginUploadAttachment"] = factory(root["wangEditor"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__857__) {
return 